export default {
  rankOrder: {
    ariaAddOption: 'Idagdag ang {label} sa niraranggo na listahan',
    ariaMoveUp: 'Ilipat pataas ang {label}',
    ariaMoveDown: 'Ilipat pababa ang {label}',
    ariaRemoveOption: 'Alisin ang {label} mula sa niraranggo na listahan',
  },
  coe: {
    ariaDisclaimer: 'Paunawa',
    ariaQuestion: 'Tanong',
    ariaConversationHistory: 'Kasaysayan ng usapan',
    ariaYourResponse: 'Ang iyong sagot {number}',
    ariaFollowUpQuestion: 'Follow-up na tanong {number}',
    ariaResponseInput: 'Patlang ng sagot',
    ariaRespondingTo: 'Sumasagot sa',
    ariaSendResponse: 'Ipadala ang sagot',
    ariaThinking: 'Nag-iisip'
  },
  deviceView: {
    toolbar: 'Preview na device',
    mobile: 'Mobile',
    tablet: 'Tablet',
    desktop: 'Desktop'
  },
  header: {
    customLogoAlt: 'Logo',
    defaultLogoAlt: 'QuestDIY logo'
  }
}
